import { Instagram, Facebook, Linkedin } from "lucide-react";

const Footer = ({ onAdminClick }) => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { label: "Services", href: "#services" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "Experiences", href: "#experiences" },
    { label: "About", href: "#about" },
    { label: "Contact", href: "#contact" },
  ];

  const scrollToSection = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      const navHeight = 80;
      const elementPosition = element.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({
        top: elementPosition - navHeight,
        behavior: "smooth",
      });
    }
  };

  return (
    <footer className="bg-bark text-cream/90" data-testid="footer">
      <div className="container-custom py-16">
        <div className="grid md:grid-cols-3 gap-12 lg:gap-20">
          {/* Brand */}
          <div>
            <h3 className="font-serif text-2xl text-gold-mid mb-4">
              StayCraft Studio
            </h3>
            <p className="text-sm text-cream/70 mb-2">
              Airbnb Management · Listing Optimisation · Local Experiences
            </p>
            <p className="text-sm text-cream/50">
              Bribie Island, Queensland
            </p>

            {/* Social Links */}
            <div className="flex gap-4 mt-6">
              <a
                href="#"
                className="w-10 h-10 border border-cream/20 flex items-center justify-center text-cream/50 hover:text-gold hover:border-gold transition-colors"
                aria-label="Instagram"
              >
                <Instagram size={18} />
              </a>
              <a
                href="#"
                className="w-10 h-10 border border-cream/20 flex items-center justify-center text-cream/50 hover:text-gold hover:border-gold transition-colors"
                aria-label="Facebook"
              >
                <Facebook size={18} />
              </a>
              <a
                href="#"
                className="w-10 h-10 border border-cream/20 flex items-center justify-center text-cream/50 hover:text-gold hover:border-gold transition-colors"
                aria-label="LinkedIn"
              >
                <Linkedin size={18} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm uppercase tracking-wider text-cream/50 mb-6">
              Quick Links
            </h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    onClick={(e) => scrollToSection(e, link.href)}
                    className="text-cream/70 hover:text-gold transition-colors text-sm"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Admin Access */}
          <div>
            <h4 className="text-sm uppercase tracking-wider text-cream/50 mb-6">
              For Hosts
            </h4>
            <p className="text-sm text-cream/70 mb-4">
              Current clients can access their dashboard here.
            </p>
            <button
              onClick={onAdminClick}
              className="text-sm text-gold hover:text-gold-mid transition-colors underline underline-offset-4"
              data-testid="admin-login-link"
            >
              Host Login →
            </button>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-cream/10">
        <div className="container-custom py-6 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-cream/40">
            © {currentYear} StayCraft Studio · All rights reserved
          </p>
          <p className="text-xs text-cream/30">
            Site by Kellie Williams
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
